import React, { useState, useRef, useEffect } from 'react';
import styles from './Tooltip.module.css';

const CustomTooltip = ({ text, children, isSegment = false, isDownloadButton = false }) => {
    const [isVisible, setIsVisible] = useState(false);
    const tooltipRef = useRef(null);
    const targetRef = useRef(null);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target) &&
                targetRef.current && !targetRef.current.contains(event.target)) {
                setIsVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            setIsVisible(true);
        }, 100);
    };

    const handleMouseLeave = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            setIsVisible(false);
        }, 100);
    };

    return (
        <div className={styles.tooltipContainer}>
            <div
                ref={targetRef}
                className={styles.tooltipTrigger}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {children}
            </div>
            {isVisible && (
                <div
                    ref={tooltipRef}
                    className={`${styles.tooltipContent} ${isSegment ? styles.tooltipBottom : ''} ${isDownloadButton ? styles.isDownloadButton : ''}`}
                >
                    {text}
                </div>
            )}
        </div>
    );
};

export default CustomTooltip;